module.exports = __webpack_public_path__ + "static/media/xyxh.409ec8fa.png";